let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7Ah1s")).then(() => parcelRequire('hpL7L'));